import { useState } from 'react'
import { Link } from '../router.js'
import { SkelloSyncSection } from '../rh/RhSyncPage.js'
import { SkelloReconciliationSection } from '../rh/ReconciliationPage.js'
import { SkelloPresenceSection } from '../rh/PresencePage.js'
import { ShadowClockSection } from './ShadowClockSection.js'
import { CleAccesPanel } from './CleAccesPanel.js'

/**
 * ADMINISTRATION → INTÉGRATIONS → SKELLO (consolidation SIRH §7).
 *
 * Les surfaces TECHNIQUES du connecteur (synchronisations, rapprochements
 * d'identités) vivent ici — hors de la navigation RH quotidienne. Le SIRH ne
 * mentionne Skello que comme provenance discrète (« Source legacy : Skello »).
 * Skello reste READ_ONLY : aucune écriture, jamais.
 */
export function SkelloIntegrationPage() {
  // La clé d'accès a son propre onglet : un seul panneau d'édition monté à la
  // fois (la Save Bar ne sert qu'une unité d'édition par écran).
  const [tab, setTab] = useState<'sync' | 'reconciliation' | 'presence' | 'shadow' | 'cle'>('sync')
  return (
    <main className="lc-page lc-stagger">
      <Link className="lc-crumb" href="/settings/integrations">← Intégrations</Link>
      <h1 className="lc-title">Skello</h1>
      <p className="lc-subtitle">
        Connecteur en lecture seule : personnel, pointages, boutiques. La surface
        technique du connecteur — les fonctions RH quotidiennes vivent dans <Link href="/equipe/rh">Équipe</Link>.
      </p>
      <nav className="lc-tabs rh-tabs" aria-label="Sections">
        <button className={`lc-tabs__tab${tab === 'sync' ? ' lc-tabs__tab--active' : ''}`} aria-pressed={tab === 'sync'} onClick={() => setTab('sync')}>Synchronisations</button>
        <button className={`lc-tabs__tab${tab === 'reconciliation' ? ' lc-tabs__tab--active' : ''}`} aria-pressed={tab === 'reconciliation'} onClick={() => setTab('reconciliation')}>Rapprochements d’identités</button>
        <button className={`lc-tabs__tab${tab === 'presence' ? ' lc-tabs__tab--active' : ''}`} aria-pressed={tab === 'presence'} onClick={() => setTab('presence')}>Présence (badgeuse)</button>
        <button className={`lc-tabs__tab${tab === 'shadow' ? ' lc-tabs__tab--active' : ''}`} aria-pressed={tab === 'shadow'} onClick={() => setTab('shadow')}>Shadow pointeuse</button>
        <button className={`lc-tabs__tab${tab === 'cle' ? ' lc-tabs__tab--active' : ''}`} aria-pressed={tab === 'cle'} onClick={() => setTab('cle')}>Clé d’accès</button>
      </nav>
      {tab === 'sync' ? <SkelloSyncSection /> : tab === 'reconciliation' ? <SkelloReconciliationSection /> : tab === 'presence' ? <SkelloPresenceSection /> : tab === 'shadow' ? <ShadowClockSection /> : <CleAccesPanel integration="skello" />}
    </main>
  )
}
